module.exports = __webpack_public_path__ + "img/dislike.11147519.png";